export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  date: string;
  image: string;
  views: number;
  likes: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'lianai-jiqiao',
    name: '恋爱技巧',
    description: '分享实用的恋爱方法与沟通技巧，助你收获甜蜜爱情',
    icon: 'ri-heart-line',
    count: 128,
  },
  {
    slug: 'hunyuan-huati',
    name: '婚恋话题',
    description: '探讨婚姻、家庭与长期关系中的各种话题',
    icon: 'ri-home-heart-line',
    count: 96,
  },
  {
    slug: 'qinggan-zixun',
    name: '情感咨询',
    description: '专业情感分析与建议，帮你解决感情困惑',
    icon: 'ri-psychotherapy-line',
    count: 85,
  },
  {
    slug: 'yuehui-gushi',
    name: '约会故事',
    description: '真实的约会经历与浪漫故事分享',
    icon: 'ri-coupon-line',
    count: 73,
  },
  {
    slug: 'xinli-chengzhang',
    name: '心理成长',
    description: '从心理学角度探索自我成长与情感成熟',
    icon: 'ri-brain-line',
    count: 64,
  },
  {
    slug: 'liangxing-goutong',
    name: '两性沟通',
    description: '男女思维差异解析与高效沟通方法',
    icon: 'ri-chat-smile-2-line',
    count: 58,
  },
];

export const articles: Article[] = [
  {
    slug: 'ruhe-zai-diyici-yuehui-liuxia-hao-yinxiang',
    title: '如何在第一次约会中留下好印象？10个实用技巧分享',
    excerpt: '第一次约会总是让人紧张又期待。本文为你整理了10个经过验证的实用技巧，帮助你在初次见面时展现最好的自己，让对方对你留下深刻而美好的印象。',
    content: `<p>第一次约会，是两颗心初次靠近的时刻。每个人都希望能在对方心中留下美好的第一印象。但紧张、不安、期待交织在一起，往往让人不知所措。</p>

<h2>1. 选择合适的地点</h2>
<p>约会地点的选择至关重要。建议选择安静舒适的咖啡厅或有情调的餐厅，避免过于嘈杂的环境。一个好的环境能让双方都放松下来，更自然地交流。如果你们都喜欢户外活动，一次轻松的公园散步也是不错的选择。</p>

<h2>2. 穿着得体大方</h2>
<p>不需要过于隆重，但要干净整洁。穿着反映了一个人的生活态度和对他人的尊重。选择适合自己的风格，保持自然舒适就好。记住，自信是最好的装饰品。</p>

<h2>3. 准时赴约</h2>
<p>守时是基本的礼貌。提前10-15分钟到达约会地点，既显示了对这次约会的重视，也能让自己有时间调整状态。如果真的遇到突发状况，一定要提前告知对方。</p>

<h2>4. 真诚地倾听</h2>
<p>很多人在约会时过于关注自己要说什么，而忽略了倾听。真正有魅力的交流，是双向的。认真听对方说话，适时回应，让对方感受到被重视和理解。</p>

<h2>5. 保持微笑与眼神交流</h2>
<p>微笑是最美的语言，它能瞬间拉近人与人之间的距离。适当的眼神交流则传递着真诚与关注。但也不要一直盯着对方看，保持自然就好。</p>

<h2>6. 分享有趣的故事</h2>
<p>准备一些轻松有趣的话题和故事，避免一上来就聊沉重或过于私密的话题。可以分享一些旅行经历、有趣的爱好或者工作中的小趣事。</p>

<h2>7. 不要一直看手机</h2>
<p>这是约会中的大忌。把手机调成静音放在包里，全身心地投入到和对方的交流中。没有什么比对方一直在刷手机更让人感到不被尊重的了。</p>

<h2>8. 注意餐桌礼仪</h2>
<p>如果是用餐约会，基本的餐桌礼仪不能忽视。细嚼慢咽、不大声说话、不用手机，这些小细节都能体现一个人的修养。</p>

<h2>9. 适度的幽默感</h2>
<p>幽默能让气氛变得轻松愉快。但要注意分寸，避免低俗笑话或过于尖锐的玩笑。温和、智慧的幽默最能打动人心。</p>

<h2>10. 结束后主动表达感谢</h2>
<p>约会结束后，可以简单发一条消息表达感谢，比如"今天和你聊天很开心，谢谢你抽出时间"。这样的小举动既礼貌又能为下次约会做铺垫。</p>

<p>总的来说，第一次约会的核心是<strong>真诚和自然</strong>。不需要刻意扮演别人，做最真实的自己，才能找到真正适合你的人。祝你的每一次约会都能收获美好！</p>`,
    category: '恋爱技巧',
    categorySlug: 'lianai-jiqiao',
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20yet%20friendly%20headshot&width=120&height=120&seq=author-xiaoyu&orientation=squarish',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20cozy%20cafe%20setting%20with%20two%20coffee%20cups%20on%20wooden%20table%2C%20warm%20soft%20lighting%2C%20elegant%20minimal%20interior%2C%20gentle%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=article-01&orientation=landscape',
    views: 12580,
    likes: 856,
    comments: 234,
    tags: ['第一次约会', '恋爱技巧', '约会建议', '人际交往'],
    isHot: true,
    isFeatured: true,
  },
  {
    slug: 'yuanjuli-lianai-ruhe-weichi',
    title: '异地恋如何维持感情温度？过来人的6个经验之谈',
    excerpt: '异地恋是很多情侣面临的挑战。距离虽然增加了相处的难度，但并不代表感情一定会降温。本文总结了6个维持异地恋感情温度的有效方法。',
    content: `<p>异地恋，被很多人称为"爱情的试金石"。当两个人身处不同的城市，甚至不同的国家，如何让感情保持温度，成为了每对异地恋情侣必须面对的课题。</p>

<h2>1. 建立固定的沟通节奏</h2>
<p>异地恋中最怕的就是沟通断层。建立固定的沟通节奏非常重要。可以是每天睡前的视频通话，也可以是每周固定的"约会之夜"。让彼此知道什么时候能找到对方，减少不必要的不安和猜疑。</p>

<h2>2. 一起做同一件事</h2>
<p>即使身处两地，也可以创造共同的体验。比如同时看一部电影然后讨论剧情，一起在线玩一款游戏，或者读同一本书分享感受。这些共同经历会成为感情的纽带。</p>

<h2>3. 给彼此惊喜</h2>
<p>偶尔给对方寄一份手写的信件、突然点一份外卖送到对方家里、或者寄一个小礼物。这些小小的惊喜能让对方感受到你的用心和在意。</p>

<h2>4. 规划见面和未来</h2>
<p>有一个可以期待的见面日期，对于维持异地恋非常重要。同时，也要一起规划未来——你们什么时候能够结束异地？对未来的生活有什么共同的憧憬？这些都是在黑暗中照亮前路的明灯。</p>

<h2>5. 信任彼此，给彼此空间</h2>
<p>异地恋中，信任是基石。不要因为对方没有秒回消息就胡思乱想，也不要试图监控对方的一举一动。健康的感情需要信任，也需要各自独立的空间。</p>

<h2>6. 学会处理情绪和冲突</h2>
<p>文字沟通容易产生误解，视频通话又可能因为网络问题中断。异地恋中的冲突往往更加棘手。学会在冷静下来之后再沟通，多用"我感受"而非"你总是"这样的表达方式。</p>

<p>异地恋虽然艰难，但只要两个人真心相爱并愿意为之付出努力，距离从来不是不可逾越的障碍。愿每一个异地恋中的你，都能等到团聚的那一天。</p>`,
    category: '恋爱技巧',
    categorySlug: 'lianai-jiqiao',
    author: '阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20gentle%20smile%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20casual%20headshot&width=120&height=120&seq=author-ajie&orientation=squarish',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20wooden%20desk%20with%20warm%20lamp%20light%2C%20cozy%20evening%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20minimalist%20composition&width=800&height=450&seq=article-02&orientation=landscape',
    views: 9820,
    likes: 723,
    comments: 189,
    tags: ['异地恋', '恋爱技巧', '感情维护', '长期关系'],
    isHot: true,
    isFeatured: false,
  },
  {
    slug: 'jiehun-qian-bixu-tantao-de-sange-wenti',
    title: '结婚前必须探讨的三个关键问题，别等婚后才发现',
    excerpt: '婚姻不是恋爱的终点，而是一段全新旅程的开始。在步入婚姻殿堂之前，有三类关键问题值得每对准新人认真讨论，这些问题将影响你们未来几十年的生活质量。',
    content: `<p>恋爱的时候，我们往往只看到对方最好的一面。但婚姻是柴米油盐的日常，是两个人最真实的生活交织。在决定共度一生之前，有些问题值得认真探讨。</p>

<h2>一、金钱观与财务规划</h2>
<p>金钱问题是导致夫妻矛盾的最常见原因之一。婚前需要坦诚地讨论：</p>
<ul>
<li>各自的收入、负债和储蓄情况</li>
<li>婚后采用共同账户还是分开管理</li>
<li>大额消费的决策机制</li>
<li>对父母的经济支持计划</li>
<li>购房、育儿等长期财务目标</li>
</ul>
<p>不要觉得谈钱伤感情。恰恰相反，坦诚地讨论财务问题，是建立婚姻信任的重要一步。</p>

<h2>二、家庭观与角色期待</h2>
<p>每个人对"理想的家庭"都有不同的想象。你需要了解：</p>
<ul>
<li>对方如何看待夫妻各自在家庭中的角色</li>
<li>家务如何分配</li>
<li>是否与父母同住</li>
<li>对生育的规划（要不要孩子、要几个、什么时候要）</li>
<li>孩子的教育理念</li>
</ul>
<p>很多矛盾源于期望的错位，而非谁对谁错。提前沟通清楚，能避免大量不必要的摩擦。</p>

<h2>三、冲突处理与沟通方式</h2>
<p>没有不吵架的夫妻，关键在于如何处理分歧：</p>
<ul>
<li>你们在面对分歧时的处理方式是否兼容</li>
<li>是否愿意为了关系学习更好的沟通方法</li>
<li>在重大问题上能否达成妥协</li>
<li>对"冷战"的态度</li>
</ul>
<p>了解彼此的沟通风格和冲突处理模式，能让你们在未来的矛盾中更加从容。</p>

<p>婚姻是一场需要两个人共同努力的马拉松，而不是一场百米冲刺。在起跑之前做好充分的准备，才能跑得更远、更稳。</p>`,
    category: '婚恋话题',
    categorySlug: 'hunyuan-huati',
    author: '思雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20portrait%20with%20thoughtful%20expression%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot&width=120&height=120&seq=author-siyu&orientation=squarish',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20wedding%20rings%20on%20soft%20cream%20fabric%20with%20gentle%20natural%20lighting%2C%20minimal%20composition%2C%20warm%20romantic%20atmosphere%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=article-03&orientation=landscape',
    views: 15630,
    likes: 1204,
    comments: 345,
    tags: ['婚姻', '婚前准备', '婚恋话题', '家庭规划'],
    isHot: true,
    isFeatured: true,
  },
  {
    slug: 'shilian-hou-ruhe-zou-chu-lai',
    title: '失恋后如何快速走出阴影？心理咨询师的5步疗愈法',
    excerpt: '失恋的痛苦是真实的，但你并不需要一直沉浸在悲伤中。本文从心理学角度出发，为你提供一套系统的5步疗愈方案，帮助你重拾自信与希望。',
    content: `<p>失恋，是很多人都要经历的人生课题。那种心痛的感觉如此真实——失眠、食欲不振、做什么都提不起兴趣。但请相信，这一切都会过去的。</p>

<h2>第一步：允许自己悲伤</h2>
<p>很多人试图用忙碌来麻痹自己，假装一切都好。但被压抑的情绪并不会消失，它们会在某个时刻以更激烈的方式爆发。给自己设定一个"悲伤期限"——比如一周。在这段时间里，你可以尽情哭泣、写日记、听伤感的音乐。承认痛苦，是疗愈的开始。</p>

<h2>第二步：切断联系，创造空间</h2>
<p>在最初的阶段，暂时切断与前任的联系是必要的。这不是绝情，而是给自己创造愈合的空间。删除或隐藏社交媒体上的互动，暂时收起那些会勾起回忆的物品。物理上的距离有助于心理上的断舍。</p>

<h2>第三步：重新建立日常生活节奏</h2>
<p>失恋往往会打乱正常的生活节奏。试着重新建立规律的作息：按时吃饭、保证睡眠、适度运动。这些看似简单的事情，能帮助你重新获得对生活的掌控感。</p>

<h2>第四步：探索新的可能性</h2>
<p>一段感情的结束，也是一个新开始的契机。试着学习一项新技能、加入一个兴趣小组、去一直想去但没去的地方旅行。新的体验能帮助你重新认识自己，发现生活中更多的可能性。</p>

<h2>第五步：重建自我认同感</h2>
<p>很多人在感情中过度依赖对方来定义自己。现在，是时候重新认识自己了。写下你的优点、你擅长的事情、你引以为傲的经历。你是完整的、独立的、值得被爱的个体。</p>

<p>记住，失恋不是失败，它只是告诉你，那个人不是对的人。每一次心痛都在为真正的幸福让路。给自己时间，给自己温柔，你会好起来的。</p>`,
    category: '情感咨询',
    categorySlug: 'qinggan-zixun',
    author: '心理咨询师林悦',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20therapist%20portrait%20with%20calm%20reassuring%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20trustworthy%20headshot&width=120&height=120&seq=author-linyue&orientation=squarish',
    date: '2026-07-22',
    image: 'https://readdy.ai/api/search-image?query=Soft%20sunlight%20streaming%20through%20window%20onto%20minimalist%20room%20with%20comfortable%20armchair%20and%20small%20plant%2C%20peaceful%20healing%20atmosphere%2C%20cream%20and%20warm%20beige%20tones&width=800&height=450&seq=article-04&orientation=landscape',
    views: 21340,
    likes: 1856,
    comments: 467,
    tags: ['失恋', '情感疗愈', '心理成长', '自我重建'],
    isHot: true,
    isFeatured: false,
  },
  {
    slug: 'nanyou-bu-zhudong-lianxi-zenmeban',
    title: '男朋友不主动联系我怎么办？先别急，试试这三个方法',
    excerpt: '很多女生都有这样的困扰：为什么男朋友总是不主动联系？是变心了还是不在乎了？在焦虑之前，先冷静下来，看看这三个角度是否能帮你找到答案。',
    content: `<p>"他为什么不主动找我？是不是不喜欢我了？"这样的疑问困扰着很多恋爱中的女生。在陷入焦虑和自我怀疑之前，让我们从理性的角度来分析一下。</p>

<h2>方法一：理解男女沟通模式的差异</h2>
<p>心理学研究表明，男性和女性在沟通需求上存在天然的差异。女性通常更倾向于通过频繁的联系来获得安全感，而男性则可能觉得"没什么特别的事就不需要联系"。这不代表不在乎，而是表达关心的方式不同。试着理解这种差异，而不是简单地归咎于"不爱了"。</p>

<h2>方法二：表达需求，而非指责</h2>
<p>如果你确实需要更多的联系和关注，可以试着用积极的方式表达。与其说"你为什么总是不主动找我"，不如说"我喜欢收到你的消息，那会让我觉得很开心"。前一种表达方式容易让对方产生防御心理，后一种则更容易被接受。</p>

<h2>方法三：丰富自己的生活</h2>
<p>当你的生活丰富多彩时，你就不会把所有注意力都放在"他有没有联系我"这件事上。培养自己的兴趣爱好，经营自己的社交圈，提升自己的能力和魅力。当你变得更有吸引力时，对方自然会更加主动。</p>

<p>最重要的是，一段健康的感情应该是双向奔赴的。如果经过真诚的沟通后，情况仍然没有改善，那也许你需要重新审视这段关系是否真的适合你。</p>`,
    category: '两性沟通',
    categorySlug: 'liangxing-goutong',
    author: '小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20bright%20confident%20smile%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20headshot&width=120&height=120&seq=author-xiaolu&orientation=squarish',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Woman%20sitting%20by%20window%20with%20phone%20in%20hand%20looking%20thoughtful%2C%20warm%20afternoon%20light%2C%20cozy%20minimalist%20interior%2C%20cream%20and%20soft%20warm%20tones&width=800&height=450&seq=article-05&orientation=landscape',
    views: 18760,
    likes: 1432,
    comments: 521,
    tags: ['两性沟通', '恋爱困惑', '沟通技巧', '情感建议'],
    isHot: true,
    isFeatured: false,
  },
  {
    slug: 'xiangqin-zhong-de-na-xie-leiren-shunjian',
    title: '相亲中的那些雷人瞬间，笑着笑着就哭了',
    excerpt: '相亲是现代都市男女寻找另一半的重要途径之一。在这个过程中，总会遇到一些让人哭笑不得的奇葩经历。来看看这些真实故事，你是否也遇到过？',
    content: `<p>相亲，这个古老又现代的社交方式，承载了太多单身男女的期待与无奈。每一次相亲都像是一场冒险，你永远不知道对面坐着的是怎样一个人。</p>

<h2>故事一：三句话不离妈妈的"妈宝男"</h2>
<p>小雯经人介绍认识了一位外表条件不错的男生。刚坐下，对方第一句话是"我妈说这家餐厅的牛排不错"，第二句话是"我妈觉得女孩子应该会做饭"，第三句话是"我妈希望我们今年就能结婚"。小雯礼貌地吃完这顿饭，然后再也没有联系过对方。</p>

<h2>故事二："你能接受AA制吗？"</h2>
<p>阿琳和相亲对象约在一家日料店。两人相谈甚欢，直到结账时，男方拿出计算器，精确到分地计算了各自应该付的金额。"你的那份三文鱼比我的多两片，所以你应该多付18块5。"阿琳当场石化。</p>

<h2>故事三："我是来考察的"</h2>
<p>大伟遇到了一位自称"相亲经验丰富"的女生。整顿饭她都在用审视的目光打量他，不时在手机上做着记录。最后她说："总体来说你还不错，我给70分。但我觉得你还需要再提升一下，下次见面我再给你打分。"大伟表示：谢谢您的考核，我不需要补考。</p>

<h2>故事四：带着亲友团来的</h2>
<p>思思到达约定地点时，发现对方带了五个人——父母、姐姐、姐夫和一位据说是"家族里最有眼光"的阿姨。整场相亲变成了七对一的面试，各种问题轮番轰炸。思思说她当时只想找个地缝钻进去。</p>

<p>虽然相亲路上奇葩不断，但也总有那些让人心头一暖的相遇。希望每一个在相亲路上的你，都能保持幽默感和开放心，在不经意间遇到那个对的人。</p>`,
    category: '约会故事',
    categorySlug: 'yuehui-gushi',
    author: '编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Editorial%20team%20portrait%20Asian%20style%2C%20warm%20professional%20look%2C%20simple%20cream%20background%2C%20friendly%20headshot&width=120&height=120&seq=author-bianjibu&orientation=squarish',
    date: '2026-07-18',
    image: 'https://readdy.ai/api/search-image?query=Humorous%20illustration%20of%20awkward%20blind%20date%20scene%20at%20restaurant%2C%20warm%20color%20palette%2C%20cream%20and%20soft%20pink%20tones%2C%20minimal%20artistic%20style&width=800&height=450&seq=article-06&orientation=landscape',
    views: 25680,
    likes: 2103,
    comments: 689,
    tags: ['相亲', '约会故事', '趣事分享', '社交经历'],
    isHot: true,
    isFeatured: true,
  },
  {
    slug: 'ruhe-tisheng-ziwo-jiazhi-gan',
    title: '如何在感情中保持自我价值感？心理学家给出的4个建议',
    excerpt: '在恋爱中失去自我是很多人都会遇到的问题。当你把全部幸福的希望寄托在另一个人身上时，你就已经失去了感情中最重要的底气。以下是提升自我价值感的实用建议。',
    content: `<p>你有没有发现，有些人一旦恋爱就完全变了一个人？以前的朋友不联系了，爱好放弃了，生活重心全部围绕着对方转。这样的感情看似投入，实则危险。</p>

<h2>1. 保持独立的经济能力</h2>
<p>无论是男生还是女生，拥有独立的经济来源是保持自我价值感的基础。经济独立意味着你有选择的权利——你可以选择和谁在一起，也可以选择离开一段不健康的关系。</p>

<h2>2. 维护自己的社交圈</h2>
<p>很多人在恋爱后就忽视了朋友。但朋友是你身份认同的重要组成部分。保持和好友的联系，定期聚会，这些关系是你在感情波动时的稳定支撑。</p>

<h2>3. 持续个人成长</h2>
<p>当你不断学习新东西、提升自己时，你的自我价值感会自然提升。无论是学一门语言、考一个证书、还是坚持健身，这些都在告诉你：我是一个不断进步的人。</p>

<h2>4. 学会独处</h2>
<p>能够享受独处时光的人，往往在感情中更加从容。当你不需要依赖他人来填充自己的时间时，你给予的爱会更加纯粹和自由。</p>

<p>记住，最好的爱情是两个完整的人走到一起，而不是两个半个人拼凑成一个整体。</p>`,
    category: '心理成长',
    categorySlug: 'xinli-chengzhang',
    author: '心理咨询师林悦',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20therapist%20portrait%20with%20calm%20reassuring%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20trustworthy%20headshot&width=120&height=120&seq=author-linyue-2&orientation=squarish',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Person%20meditating%20peacefully%20in%20minimalist%20room%20with%20sunlight%2C%20self-care%20concept%2C%20warm%20cream%20and%20beige%20tones%2C%20calm%20atmosphere&width=800&height=450&seq=article-07&orientation=landscape',
    views: 11230,
    likes: 987,
    comments: 256,
    tags: ['自我成长', '心理成长', '价值感', '独立人格'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'hunhou-caizhidao-de-shi-ge-zhenxiang',
    title: '婚后才知道的十个真相，未婚的人一定要看',
    excerpt: '婚姻和恋爱完全是两回事。很多人在婚后才发现，原来理想中的婚姻生活和现实有如此大的差距。本文总结了十个人们婚后才知道的真相，希望能给未婚的你一些参考。',
    content: `<p>恋爱时我们戴着玫瑰色的眼镜看对方，而婚姻则把这副眼镜摘了下来。以下是婚姻中的一些真相，它们不一定是坏事，但提前了解会让你更有准备。</p>

<h2>1. 爱情会从轰轰烈烈变成细水长流</h2>
<p>这其实是件好事。激情退去后，留下的是更深层次的亲密和默契。真正的婚姻不是每天都像热恋，而是在平凡的日子里依然选择彼此。</p>

<h2>2. 对方的家人就是你的家人</h2>
<p>结婚不仅仅是和一个人在一起，也是和对方的整个家庭建立联系。婆媳关系、翁婿相处，这些都是需要用心经营的部分。</p>

<h2>3. 生活习惯的磨合比你想象中更难</h2>
<p>他喜欢熬夜你看重早睡，她爱整洁你比较随意——这些看似微小的生活习惯差异，在日复一日的相处中可能会成为矛盾的导火索。</p>

<h2>4. 钱的问题永远绕不开</h2>
<p>房贷、车贷、日常开销、双方父母的赡养……婚后的财务压力远比恋爱时大得多。建立健康的家庭财务体系是婚姻稳定的重要保障。</p>

<h2>5. 孩子改变一切</h2>
<p>有了孩子之后，二人世界基本宣告结束。你需要学会在为人父母的同时，依然维持夫妻之间的亲密关系。</p>

<h2>6-10. （更多内容请查看完整文章）</h2>

<p>知道这些真相不是为了恐婚，而是为了让你以更成熟的心态走进婚姻。毕竟，婚姻不是童话，但依然可以是美好的人生选择。</p>`,
    category: '婚恋话题',
    categorySlug: 'hunyuan-huati',
    author: '思雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20portrait%20with%20thoughtful%20expression%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot&width=120&height=120&seq=author-siyu-2&orientation=squarish',
    date: '2026-07-12',
    image: 'https://readdy.ai/api/search-image?query=Couple%20sitting%20together%20on%20sofa%20in%20warm%20living%20room%2C%20soft%20evening%20lighting%2C%20peaceful%20domestic%20scene%2C%20cream%20and%20warm%20beige%20tones&width=800&height=450&seq=article-08&orientation=landscape',
    views: 19840,
    likes: 1567,
    comments: 423,
    tags: ['婚姻真相', '婚恋话题', '婚后生活', '人生经验'],
    isHot: false,
    isFeatured: true,
  },
  {
    slug: 'zenyang-caineng-zhao-dao-dui-de-ren',
    title: '怎样才能找到对的人？比择偶标准更重要的三件事',
    excerpt: '很多人列了一长串择偶标准，却依然找不到合适的伴侣。也许问题不在于标准不够细致，而在于我们找错了方向。本文探讨比"标准"更重要的三件事。',
    content: `<p>身高180以上、年收入30万+、有房有车、温柔体贴……这样的择偶标准你是否也很熟悉？但为什么满足了所有条件的人，却可能依然不是"对的人"？</p>

<h2>一、先成为对的人</h2>
<p>与其苦苦寻找"对的人"，不如先让自己成为"对的人"。当你不断成长、完善自我时，你吸引来的人的层次也会相应提升。感情的底层逻辑是价值匹配，你想要什么样的人，就先让自己配得上那样的人。</p>

<h2>二、重视价值观的契合度</h2>
<p>外貌会衰老，激情会消退，但价值观是最稳定的。你们对金钱的态度是否一致？对家庭的理解是否相合？对人生意义的追求是否同频？这些深层次的一致性，比表面的条件匹配更加重要。</p>

<h2>三、看对方如何对待他人</h2>
<p>一个人在追求你时对你的好，可能是经过"滤镜美化"的。但对方如何对待服务员、如何对待家人、如何对待朋友，这些细节往往更真实地反映出一个人的品格。</p>

<p>找到对的人不是一场精确的匹配游戏，而是一次真诚的相互奔赴。放下那些条条框框，用心去感受，也许对的人就在你不经意的转角处。</p>`,
    category: '婚恋话题',
    categorySlug: 'hunyuan-huati',
    author: '阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20gentle%20smile%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20casual%20headshot&width=120&height=120&seq=author-ajie-2&orientation=squarish',
    date: '2026-07-10',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20walking%20together%20on%20tree-lined%20path%20in%20warm%20sunset%20light%2C%20romantic%20peaceful%20atmosphere%2C%20cream%20and%20warm%20golden%20tones&width=800&height=450&seq=article-09&orientation=landscape',
    views: 14250,
    likes: 1089,
    comments: 312,
    tags: ['择偶', '婚恋话题', '价值观', '人生伴侣'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'biao-bai-bei-ju-hou-zenmeban',
    title: '表白被拒后怎么办？别慌，这才是最正确的处理方式',
    excerpt: '鼓起勇气表白却被拒绝，这种感觉确实不好受。但被拒绝并不意味着你不够好，只是说明你们不合适。来看看如何优雅地面对拒绝，甚至把关系处理得更好。',
    content: `<p>你鼓足了所有的勇气，把藏在心里很久的话说了出来。然后，对方说了一句"对不起"。那一刻，你的世界仿佛崩塌了。但请深呼吸，这真的没有那么糟糕。</p>

<h2>第一步：尊重对方的决定</h2>
<p>被拒绝后第一件要做的事，就是体面地接受。说一句"没关系，我理解"然后退一步。不要追问为什么，不要试图说服对方，更不要情绪失控。你的体面会让对方对你保持尊重，也让你自己保留尊严。</p>

<h2>第二步：给自己时间和空间</h2>
<p>被拒绝后，暂时保持距离是必要的。这不是逃避，而是让双方都有时间消化这件事。这段时间里，不要反复翻看聊天记录，不要stalk对方的社交媒体。把注意力放回自己身上。</p>

<h2>第三步：重新定义关系</h2>
<p>如果你们之前是朋友，被拒绝后不一定就要老死不相往来。但关系的边界需要重新定义。等到情绪平复之后，可以尝试以更轻松的方式相处。但前提是，你已经真正放下了。</p>

<h2>第四步：从中学习和成长</h2>
<p>每一次被拒绝都是一次成长的机会。反思一下，你的表达方式是否合适？你是否真正了解对方？这段经历能让你在下一次的感情中更加成熟。</p>

<p>记住，表白被拒不是对你这个人价值的否定。它只是说明，你们的频率不在同一个频道上。对的那个人，不需要你如此费力地去争取。</p>`,
    category: '情感咨询',
    categorySlug: 'qinggan-zixun',
    author: '小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20yet%20friendly%20headshot&width=120&height=120&seq=author-xiaoyu-2&orientation=squarish',
    date: '2026-07-08',
    image: 'https://readdy.ai/api/search-image?query=Person%20sitting%20alone%20on%20park%20bench%20with%20warm%20sunset%20light%2C%20reflective%20peaceful%20mood%2C%20cream%20and%20soft%20golden%20tones%2C%20healing%20atmosphere&width=800&height=450&seq=article-10&orientation=landscape',
    views: 16780,
    likes: 1345,
    comments: 398,
    tags: ['表白', '情感咨询', '拒绝', '心理调适'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'qinglv-jian-feijiankang-de-zhengchao-fangshi',
    title: '情侣间健康的争吵方式：吵完更亲密的5个原则',
    excerpt: '吵架不可怕，可怕的是用错误的方式吵架。学会健康地表达分歧，不仅不会伤害感情，反而能让你们更加亲密。这5个原则值得每对情侣学习。',
    content: `<p>没有不吵架的情侣，但有些情侣越吵越亲密，有些却越吵越疏远。区别就在于——你们是用什么方式在吵架。</p>

<h2>原则一：就事论事，不翻旧账</h2>
<p>吵架时最容易犯的错误就是翻旧账。"你上次也这样！""你每次都……！"一旦开始翻旧账，当前的矛盾就会升级为全面的战争。记住，只讨论当下的问题，不要扯到过去。</p>

<h2>原则二：用"我"开头，不用"你"攻击</h2>
<p>"你从来不考虑我的感受"和"我感觉自己的想法没有被听到"，这两句话传达的信息相似，但效果完全不同。前者是攻击，后者是表达。用"我感受"代替"你总是"，能让对方更容易接受。</p>

<h2>原则三：不涉及人格攻击</h2>
<p>再生气也不要说"你就是个自私的人""你太差劲了"这种话。批评行为，不要否定人格。一旦上升到人格攻击，伤害往往是不可逆的。</p>

<h2>原则四：适时按下暂停键</h2>
<p>当双方情绪都过于激动时，继续争吵只会让情况更糟。约定一个"暂停暗号"，任何一方都可以使用。暂停不是逃避，而是给双方冷静下来的时间。但要约定好回来继续沟通的时间。</p>

<h2>原则五：吵完后的修复仪式</h2>
<p>冲突结束后，一个拥抱、一句"虽然我们吵架了但我还是很爱你"，对于修复关系非常重要。建立你们的"修复仪式"，让每次争吵都能以更紧密的连接结束。</p>`,
    category: '两性沟通',
    categorySlug: 'liangxing-goutong',
    author: '心理咨询师林悦',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20therapist%20portrait%20with%20calm%20reassuring%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20trustworthy%20headshot&width=120&height=120&seq=author-linyue-3&orientation=squarish',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Couple%20having%20calm%20conversation%20in%20cozy%20living%20room%2C%20warm%20indoor%20lighting%2C%20understanding%20and%20communication%20concept%2C%20cream%20and%20beige%20tones&width=800&height=450&seq=article-11&orientation=landscape',
    views: 8910,
    likes: 765,
    comments: 187,
    tags: ['争吵', '两性沟通', '冲突处理', '亲密关系'],
    isHot: false,
    isFeatured: false,
  },
  {
    slug: 'cong-haoyou-bian-cheng-lianren-de-gushi',
    title: '从好友变成恋人是种什么体验？三位过来人的真实分享',
    excerpt: '友达以上，恋人未满——这是很多人经历过或正在经历的微妙关系阶段。当友情跨越那条线变成爱情，结果会是怎样的呢？三位经历过的好友分享了他们的故事。',
    content: `<p>从朋友变成恋人，听起来像是浪漫电影里的情节。但当这件事发生在现实生活中，它究竟会带来什么？是惊喜还是尴尬？是更亲密还是更疏远？</p>

<h2>小美的故事：青梅竹马，顺其自然</h2>
<p>"我和他认识十年了，从高中到大学一直都是最好的朋友。我们的转变不是某一个瞬间的决定，而是日积月累的自然结果。突然有一天，我发现看到他和别人约会时心里会不舒服，才意识到自己早就喜欢上他了。幸运的是，他也有同样的感觉。现在我们已经在一起三年了，我觉得从朋友开始的感情最大的好处就是——我们太了解对方了，不需要伪装，不需要试探。"</p>

<h2>大伟的故事：表白失败后的尴尬</h2>
<p>"我暗恋我的好朋友两年，终于鼓起勇气表白了。但她拒绝了，说不想失去我这个朋友。之后我们试图维持友谊，但那种尴尬感挥之不去。聊天变得刻意，见面变得不自然。半年后我们渐渐疏远了。我有时候会后悔，如果当初没有表白，是不是至少还能留住一个好朋友。"</p>

<h2>琳琳的故事：结婚后友情变成了最坚实的基石</h2>
<p>"我和我先生做了四年朋友才开始交往。结婚后我才真正体会到，友情其实是婚姻最坚实的基石。恋爱时的心动可能会消退，但多年的了解和信任不会。当我们面临困难时，那份老朋友般的默契总能帮助我们度过难关。"</p>

<p>从朋友变恋人，结局各不相同。但有一点是共通的：无论结果如何，真诚的感情和尊重对方的决定，永远不会错。</p>`,
    category: '约会故事',
    categorySlug: 'yuehui-gushi',
    author: '编辑部',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Editorial%20team%20portrait%20Asian%20style%2C%20warm%20professional%20look%2C%20simple%20cream%20background%2C%20friendly%20headshot&width=120&height=120&seq=author-bianjibu-2&orientation=squarish',
    date: '2026-07-01',
    image: 'https://readdy.ai/api/search-image?query=Two%20friends%20talking%20and%20laughing%20together%20in%20cozy%20cafe%2C%20warm%20natural%20light%2C%20genuine%20connection%2C%20cream%20and%20soft%20warm%20tones&width=800&height=450&seq=article-12&orientation=landscape',
    views: 12760,
    likes: 1023,
    comments: 278,
    tags: ['好友变恋人', '约会故事', '真实经历', '友情爱情'],
    isHot: false,
    isFeatured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小雨',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20headshot&width=120&height=120&seq=testimonial-01&orientation=squarish',
    content: '在爱情岛论坛上看了很多情感文章，让我在失恋后重新找到了方向。这里的每一篇文章都很走心，感觉像是朋友在跟你聊天。',
    rating: 5,
  },
  {
    id: 2,
    name: '阿杰',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20gentle%20smile%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20casual%20headshot&width=120&height=120&seq=testimonial-02&orientation=squarish',
    content: '异地恋的时候经常会上来看看别人的经验分享，得到了很多实用的建议。感谢这个平台让我坚持到了最后，现在我们终于团聚了！',
    rating: 5,
  },
  {
    id: 3,
    name: '思雨',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20portrait%20with%20thoughtful%20expression%2C%20soft%20natural%20lighting%2C%20simple%20cream%20background%2C%20professional%20headshot&width=120&height=120&seq=testimonial-03&orientation=squarish',
    content: '结婚前在这里看了很多关于婚姻的讨论，让我对婚姻有了更理性的认识。现在结婚两年了，回头看那些文章，依然觉得很受用。',
    rating: 5,
  },
  {
    id: 4,
    name: '小鹿',
    location: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20bright%20confident%20smile%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20headshot&width=120&height=120&seq=testimonial-04&orientation=squarish',
    content: '最喜欢的板块是心理咨询师的文章，每一篇都说得特别在理。按照建议去调整之后，和男朋友的关系真的变好了很多。',
    rating: 4,
  },
];

export const faqs = [
  {
    question: '爱情岛论坛亚洲是免费的吗？',
    answer: '是的，爱情岛论坛亚洲完全免费。所有文章、讨论和资源都可以免费浏览，我们致力于为亚洲用户提供高质量的情感交流平台。',
  },
  {
    question: '如何加入爱情岛论坛？',
    answer: '你只需注册一个账号即可加入我们的社区。注册后你可以发表评论、参与讨论、收藏喜欢的文章，还可以与其他会员互动交流。',
  },
  {
    question: '论坛的文章是由谁撰写的？',
    answer: '我们的文章来自多个渠道：专业心理咨询师、情感领域作家、经验丰富的编辑团队，以及社区中分享真实经历的会员。每篇文章都经过审核，确保质量。',
  },
  {
    question: '可以投稿分享自己的故事吗？',
    answer: '当然可以！我们非常欢迎会员投稿分享自己的情感故事、恋爱经验或婚恋观点。你可以通过网站上的投稿入口提交文章，我们的编辑团队会进行审核和发布。',
  },
  {
    question: '如何联系爱情岛论坛的客服？',
    answer: '你可以通过关于我们页面上的联系表单、官方邮箱或社交媒体渠道与我们取得联系。我们的客服团队会在24小时内回复你的问题。',
  },
];